import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getTransferList as getTransferListApi,
	getTransfer as getTransferApi,
	addNewTransfer as addNewTransferApi,
	updateTransfer as updateTransferApi,
	deleteTransfer as deleteTransferApi,
} from '../../helpers/transfer/backend_helper';

export const getTransferList = createAsyncThunk('transfers/getTransferList', async () => {
	try {
		const response = getTransferListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getTransfer = createAsyncThunk('transfers/getTransfer', async transfer_id => {
	try {
		const response = getTransferApi(transfer_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewTransfer = createAsyncThunk('transfers/addNewTransfer', async transfer => {
	try {
		const response = addNewTransferApi(transfer);
		toast.success('Transfer agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar transfer.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateTransfer = createAsyncThunk('transfers/updateTransfer', async (transfer) => {
		try {
			const response = updateTransferApi(transfer);
			toast.success('Transfer actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar transfer.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteTransfer = createAsyncThunk('transfers/deleteTransfer', async transfer => {
	try {
		const response = await deleteTransferApi(transfer);
		toast.success('Transfer eliminado exitosamente.', { autoClose: 3000 });
		return { transfer, ...response };
	} catch (error) {
		toast.error('Error al eliminar transfer.', { autoClose: 3000 });
		throw new Error(error);
	}
});
